export enum WizardStep {
    Focus,
    Goals
}